import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Repos, Breadcrumbs, NewDirectory, FolderContentsTable } from '../components/folder-contents'
import { Container, Row } from 'shards-react'
import PageTitle from "../components/common/PageTitle"
import SectionTitle from "../components/file-manager-cards/SectionTitle"
import {
  fetchAccount
} from '../redux/actions/accountActions'

const mapStateToProps = state => ({
  acct: state.acct.ACCT,
  repo: state.repo.activeRepo,
  fldrs: state.repo.directories
})

const mapDispatchToProps = dispatch => ({
  getAccount: () => dispatch(fetchAccount())
})

export default connect(mapStateToProps,mapDispatchToProps)(({ acct, fldrs, repo, getAccount }) => {

  useEffect(() => {
    console.log('acct: ', acct)
    if(!acct.ID) {
      getAccount()
    }
  },[repo])

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="File Manager" subtitle="Dashboards" className="text-sm-left mb-3" />
      </Row>

      {/* Repositories List */}
      <div className="file-manager file-manager-cards" >
        <SectionTitle title="Repositories" />
        <Repos />
      </div>

      {/* Directories Breadcrumbs */}
      <div className="file-manager file-manager-cards" >
        <SectionTitle title="Directories" />
        {<Breadcrumbs />}
      </div>

      {/* New Directory Form */}
      <div className="file-manager file-manager-cards" >
        <NewDirectory />
      </div>

      {/* UPLOADS?? */}

      {/* Folder contents Table */}
      <FolderContentsTable />
      
    </Container>
  )
})